import React, { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import LineTitle from '../atoms/titles/LineTitle';
import LinkButton from '../atoms/button/LinkButton';
import Calender from '../atoms/form/Calender';
import SelectBox from '../atoms/form/SelectBox';
import Modal from '../atoms/modal/Modal';
import CheckBox from '../atoms/form/CheckBox';
import TooltipIcon from '../molecules/TooltipIcon';
import PeopleCaption from '../atoms/PeopleCaption';
import { PeopleSelector, createPeopleSelectorOption } from '../molecules/PeopleSelector';
import {
  setAdult,
  setChildrenA,
  setChildrenB,
  setChildrenC,
  setChildren2,
  setInfant,
  setOutboundDepartureAirportId,
  setOutboundArrivalAirportId,
  setOutboundIncludeConnectingFlight,
  setOutboundDate,
  setInboundDepartureAirportId,
  setInboundArrivalAirportId,
  setInboundIncludeConnectingFlight,
  setInboundDate,
} from '../../modules/flight';
import { setPax } from '../../modules/hotel';
import { useDirections } from '../../utils/search';
import { getAirportNameFromDirectionsById } from '../../utils/input';

const flightSelector = (state) => state.flight;

const ModalRoundTrip = (props) => {
  const {
    open,
    onClose,
    onCancel,
    onClick,
    disableCalendarOutbound,
    disableCalendarInbound,
    calenderMinDateOutbound,
    calenderMinDateInbound,
    handleSearch,
  } = props;

  const directions = useDirections();

  const { flightsInput } = useSelector(flightSelector);

  const {
    people,
    airline,
    outbound,
    inbound,
  } = flightsInput;

  const {
    adult,
    childrenA,
    childrenB,
    childrenC,
    children2,
    infant,
  } = people;

  const dispatch = useDispatch();

  const handleChangeAdult = useCallback((_value) => {
    const value = Number(_value);
    dispatch(
      setAdult(value)
    );
    if ((infant + childrenC + children2) > value) {
      dispatch(
        setInfant(0)
      );
      dispatch(setChildren2(0));
      dispatch(setChildrenC(0));
    }
    dispatch(
      setPax(value + childrenA + childrenB)
    );
  }, [childrenA, childrenB, childrenC, children2, infant]);

  const handleChangeChildrenA = useCallback((_value) => {
    const value = Number(_value);
    dispatch(
      setChildrenA(value)
    );
    dispatch(
      setPax(adult + value + childrenB)
    );
  }, [adult, childrenB]);

  const handleChangeChildrenB = useCallback((_value) => {
    const value = Number(_value);
    dispatch(
      setChildrenB(value)
    );
    dispatch(
      setPax(adult + childrenA + value)
    );
  }, [adult, childrenA]);

  const handleChangeChildrenC = useCallback((_value) => {
    const value = Number(_value);
    dispatch(
      setChildrenC(value)
    );
  });

  const handleChangeChildren2 = useCallback((_value) => {
    const value = Number(_value);
    dispatch(
      setChildren2(value)
    );
  });

  const handleChangeInfant = useCallback((_value) => {
    const value = Number(_value);
    dispatch(
      setInfant(value)
    );
  }, []);

  const handleChangeOutboundDepartureAirportId = useCallback((e) => {
    dispatch(
      setOutboundDepartureAirportId(e.target.value)
    );
    dispatch(
      setInboundArrivalAirportId(e.target.value)
    );
  }, []);

  const handleChangeOutboundArrivalAirportId = useCallback((e) => {
    dispatch(
      setOutboundArrivalAirportId(e.target.value)
    );
  }, []);

  const handleChangeOutboundIncludeConnectingFlight = useCallback(() => {
    dispatch(
      setOutboundIncludeConnectingFlight(!outbound.includeConnectingFlight)
    );
  }, [outbound.includeConnectingFlight]);

  const handleChangeInboundDepartureAirportId = useCallback((e) => {
    dispatch(
      setInboundDepartureAirportId(e.target.value)
    );
  }, []);

  const handleChangeInboundIncludeConnectingFlight = useCallback(() => {
    dispatch(
      setInboundIncludeConnectingFlight(!inbound.includeConnectingFlight)
    );
  }, [inbound.includeConnectingFlight]);

  const childrenCNotes = '※（座席あり/寝具なし）のプランは設定に限りがあります。検索結果が表示されない場合や施設数が少ない場合は、（座席あり/寝具あり）もご検討ください。';
  const children2Notes = '※2026/05/19搭乗分から全日空（ANA）便をご利用の場合にのみ有効です。2歳のお子様は座席あり予約となります。<br />※詳細は上の <img class="questionIcon small" src="/dp-air/img/icons/question.png"> にてご確認ください。';

  const peopleOptions = useMemo(() => {
    const maxChildrenC = adult > 2 ? (2 - (children2 + infant)) : (adult - (children2 + infant));
    const maxChildren2 = adult > 2 ? (2 - (childrenC + infant)) : (adult - (childrenC + infant));
    const maxInfant =  adult > 2 ? (2 - (childrenC + children2)) : (adult - (childrenC + children2));
    return [
      createPeopleSelectorOption('大人', adult, 1, 6, handleChangeAdult, '', ''),
      createPeopleSelectorOption('こども(6〜11歳)', childrenA, 0, 5, handleChangeChildrenA, '', '<span>(座席あり/寝具あり/食事あり(大人同様))</span>'),
      createPeopleSelectorOption('こども(3〜5歳)', childrenB, 0, 5, handleChangeChildrenB, '', '<span>(座席あり/寝具あり/食事あり(子供用))</span>'),
      createPeopleSelectorOption(' ', childrenC, 0, maxChildrenC, handleChangeChildrenC, childrenCNotes, '<span>(座席あり/寝具なし/食事なし)</span>', true),
      createPeopleSelectorOption('こども(2歳)', children2, 0, maxChildren2, handleChangeChildren2, children2Notes, '<div class="children2_wrap"><span>(座席なし/寝具なし/食事なし)</span><span class="asterisk">(座席あり/寝具なし/食事なし)</span></div>'),
      createPeopleSelectorOption('こども(0〜1歳)', infant, 0, maxInfant, handleChangeInfant, '', '<span>(座席なし/寝具なし/食事なし)</span>'),
    ];
  },
  [
    adult, childrenA, childrenB, childrenC, children2, infant,
    handleChangeAdult, handleChangeChildrenA, handleChangeChildrenB, handleChangeChildrenC, handleChangeChildren2, handleChangeInfant,
    children2Notes,
  ]);

  const peopleValueDisplay = `大人${adult}名・こども${childrenA + childrenB + childrenC + children2}名`;

  const inboundArrivalAirportName = getAirportNameFromDirectionsById(directions, inbound.arrivalAirportId);

  return (
    <Modal
      title={'検索条件を変更する'}
      open={open}
      onClose={onClose}
      onCancel={onCancel}
      onClick={onClick}
      className="fullHeight"
    >
      <div className="searchModal">
        <div className="searchModalContent">
          <LineTitle className="iconContainer" text="旅行人数">
            <TooltipIcon>
              <PeopleCaption/>
            </TooltipIcon>
          </LineTitle>
          <div className="searchModalForm">
            <div className="searchModalFormItem alignTop">
              <div className="searchModalFormTitle">人数</div>
            </div>
            <PeopleSelector
              valueDisplay={peopleValueDisplay}
              options={peopleOptions}
            />
          </div>
        </div>
        <div className="searchModalContent">
          <LineTitle text="行き" />
          <div className="searchModalForm">
            <div className="searchModalFormItem">
              <div className="searchModalFormTitle">出発日</div>
              <div className="searchModalFormInput">
                <Calender
                  date={outbound.date}
                  onChange={(date) => dispatch(setOutboundDate(date))}
                  readOnly={disableCalendarOutbound}
                  minDate={calenderMinDateOutbound}
                />
              </div>
            </div>
            <div className="searchModalFormItem">
              <div className="searchModalFormTitle">出発地</div>
              <div className="searchModalFormInput">
                <SelectBox
                  optGroups={directions}
                  value={outbound.departureAirportId}
                  onChange={handleChangeOutboundDepartureAirportId}
                />
              </div>
            </div>
            <div className="searchModalFormItem">
              <div className="searchModalFormTitle">到着地</div>
              <div className="searchModalFormInput">
                <SelectBox
                  optGroups={directions}
                  value={outbound.arrivalAirportId}
                  onChange={handleChangeOutboundArrivalAirportId}
                />
              </div>
            </div>
            {/* https://gitlab.fqsv.net/dp-plus/front/-/issues/305 */}
            {/* <div className="searchModalFormItem">
              <CheckBox
                name="searchFlightModalOutbound"
                id="searchFlightModalOutbound"
                checked={outbound.includeConnectingFlight}
                onChange={handleChangeOutboundIncludeConnectingFlight}
              >
                乗継便を含める
              </CheckBox>
            </div> */}
          </div>
        </div>
        <div className="searchModalContent">
          <LineTitle text="帰り" />
          <div className="searchModalForm">
            <div className="searchModalFormItem">
              <div className="searchModalFormTitle">出発日</div>
              <div className="searchModalFormInput">
                <Calender
                  date={inbound.date}
                  onChange={(date) => dispatch(setInboundDate(date))}
                  readOnly={disableCalendarInbound}
                  minDate={calenderMinDateInbound ? calenderMinDateInbound : moment(outbound.date).add(1, 'days').format('YYYY-MM-DD')}
                  maxDate={moment(outbound.date).add(7, 'days').format('YYYY-MM-DD')}
                />
              </div>
            </div>
            <div className="searchModalFormItem">
              <div className="searchModalFormTitle">出発地</div>
              <div className="searchModalFormInput">
                <SelectBox
                  optGroups={directions}
                  value={inbound.departureAirportId}
                  onChange={handleChangeInboundDepartureAirportId}
                />
              </div>
            </div>
            <div className="searchModalFormItem">
              <div className="searchModalFormTitle">到着地</div>
              <div style={{ paddingLeft: 24 }}>
                {inboundArrivalAirportName}
              </div>
            </div>
            {/* https://gitlab.fqsv.net/dp-plus/front/-/issues/305 */}
            {/* <div className="searchModalFormItem">
              <CheckBox
                name="searchFlightModalInbound"
                id="searchFlightModalInbound"
                checked={inbound.includeConnectingFlight}
                onChange={handleChangeInboundIncludeConnectingFlight}
              >
                乗継便を含める
              </CheckBox>
            </div> */}
          </div>
        </div>
        <div className="action">
          <div className="research">
            <LinkButton onClick={handleSearch}>
              変更する
            </LinkButton>
          </div>
          <div className="close"><LinkButton buttonType="navigateMin" onClick={onClose}>閉じる</LinkButton></div>
        </div>
      </div>
    </Modal>
  );
};


ModalRoundTrip.defaultProps = {
};

ModalRoundTrip.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onClick: PropTypes.func,
  disableCalendarOutbound: PropTypes.bool,
  disableCalendarInbound: PropTypes.bool,
  calenderMinDateOutbound: PropTypes.string,
  calenderMinDateInbound: PropTypes.string,
  handleSearch: PropTypes.func.isRequired,
};

export default ModalRoundTrip;
